/**
 * PrintableDocument Component
 */

import { getCountryLabelFromCode, getStateLabelFromCode } from '../../../../redux/helpers/countries';
import './styles.scss';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';

import { formatAddress } from '../../../../utils/address';
import { nl2br } from '../../../../utils/react';
import { LogoBopper } from '../../../atoms/images/Icon';
import Heading from '../../../atoms/text/Heading';
import { Paragraph } from '../../../atoms/text/Label';

interface IOwnStateProps {
  businessInformation: GQL.IBusinessInformation;
  getCountryLabel(countryCode: string): string | undefined;
  getStateLabel(stateCode: string): string | undefined;
}

interface IOwnProps {
  className?: string;
  identification: {
    title: string | React.ReactNode;
    subtitle?: string | React.ReactNode;
  };
  metadata?: React.ReactNode;
  subtitle: string | React.ReactNode;
  title: string | React.ReactNode;
  type: 'invoice' | 'license';
}

type PrintableDocumentProps = IOwnStateProps & IOwnProps;

const classes = new BEM('document');

class PrintableDocument extends React.Component<PrintableDocumentProps, any> {

  renderHeader() {
    const {
      identification,
      metadata,
      subtitle,
      title,
    } = this.props;
    return (
      <div {...classes('header')}>
        <div>
          <Heading is="h4" {...classes('subtitle')}>{subtitle}</Heading>
          <Heading is="h1" {...classes('title')}>{title}</Heading>
          {metadata && <div {...classes('metadata')}>{metadata}</div>}
        </div>
        <div {...classes('identification')}>
          <LogoBopper {...classes('identification__logo')} />
          <Heading is="h2" {...classes('identification__title')}>{identification.title}</Heading>
          {identification.subtitle && (
            <Heading is="h5" {...classes('identification__subtitle')}>{identification.subtitle}</Heading>
          )}
        </div>
      </div>
    );
  }

  renderFooter() {
    const {
      businessInformation: {
        legal_name,
        address,
        commercial_details: {
          gst_number,
        },
      },
      getCountryLabel,
      getStateLabel,
    } = this.props;

    return (
      <div {...classes('footer')}>
        <LogoBopper />
        <div {...classes('footer__address')}>
          <Paragraph size="small">
            <strong>{legal_name}</strong><br />
            {nl2br(formatAddress(address, getCountryLabel, getStateLabel, true))}
          </Paragraph>
        </div>
        {this.props.type === 'invoice' && (
          <div>
            <Paragraph size="small">
              TPS/GST: {gst_number}
            </Paragraph>
          </div>
        )}
      </div>
    );
  }

  render() {
    const extraClasses = classNames(
      this.props.className,
      this.props.type,
    );

    return (
      <div {...classes('', '', extraClasses)}>
        {this.renderHeader()}
        <article {...classes('content')}>
          {this.props.children}
        </article>
        {this.renderFooter()}
      </div>
    );
  }
}

const ConnectedPrintableDocument = connect<IOwnStateProps, {}, IOwnProps, IStoreState>(
  (state) => ({
    businessInformation: state.staticData.businessInformation as GQL.IBusinessInformation,
    getCountryLabel: (countryCode) => getCountryLabelFromCode(countryCode)(state),
    getStateLabel: (stateCode) => getStateLabelFromCode(stateCode)(state),
  }),
)(PrintableDocument);

export default ConnectedPrintableDocument;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/account/PrintableDocument/index.tsx